export const TRANSFORM_COMMAND_OPTIONS = {} as const;
